const RelationalModel = require('../extensions/relational-model.js');
const RelationalCollection = require('../extensions/relational-collection.js');
const parameters = require('./parameters.js');
const _ = require('underscore');

const ActivityGroup = RelationalModel.extend({
  mutators: {
    colorCode() {
      return this._get('colorCode') ? this._get('colorCode') : '#5f554b';
    }
  }
});

const ActivityGroupCollection = RelationalCollection.extend({
  model: ActivityGroup,
  url() {
    return `${parameters.get('api_base_url')}/${parameters.get('client_token')}/activitygroups`;
  }
});

module.exports = new ActivityGroupCollection();

// declare parse method after module export to avoid cyclic dependency
ActivityGroup.prototype.parse = function(response) {
  const self = this;

  if (response.activityIdList) {
    const activities = require('./activities.js');
    const activityModels = _.map(response.activityIdList, id => ({ id, group: self }));
    response.activities = activities.extend(activities.merge(activityModels));
  }

  return response;
};



// WEBPACK FOOTER //
// ./src/data/activitygroups.js